import * as React from "react";
const SvgFiRrSpaceStationMoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12.225 2.002C8.949 1.96 5.91 3.162 3.594 5.437A11.9 11.9 0 0 0 0 14v3.5C0 19.981 2.019 22 4.5 22h15c2.481 0 4.5-2.019 4.5-4.5v-3.135C24 7.667 18.718 2.12 12.225 2.002M11.998 4q.095 0 .189.002c2.65.048 5.057 1.188 6.824 2.998H4.858l.136-.137A9.93 9.93 0 0 1 11.998 4M17 14.5V20h-3v-4a2 2 0 1 0-4 0v4H7v-5.5c0-2.236.386-4.2 1.069-5.5h7.861c.683 1.3 1.07 3.264 1.07 5.5m-15 3V14c0-1.786.464-3.497 1.334-5h2.547C5.307 10.495 5 12.386 5 14.5V20h-.5A2.5 2.5 0 0 1 2 17.5m20 0c0 1.379-1.121 2.5-2.5 2.5H19v-5.5c0-2.114-.307-4.005-.881-5.5h2.421a10.55 10.55 0 0 1 1.459 5.365z"
    />
  </svg>
);
export default SvgFiRrSpaceStationMoon;
